import type {InputDescription} from './types';

export function createInputDescription({editorId, editorName, description}: Record<'editorId' | 'editorName' | 'description', string>): InputDescription | null {
    if (!description) {
        return null;
    }
    return {
        content: description,
        id: `${editorId}-${editorName}-description`
    }
}